import React, { useEffect, useContext, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { AppSettings } from './../../config/app-settings.js';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';

function EmailDetail() {
	const context = useContext(AppSettings);
	const [mailData, setMailData] = useState();
	
	useEffect(() => {
		context.setAppContentFullHeight(true);
		context.setAppContentClass('p-3');
		
		fetch('/quantum-react/assets/data/email/inbox.json').then(res => res.json()).then((result) => { setMailData(result); });
		
		return function cleanUp() {
			context.setAppContentFullHeight(false);
			context.setAppContentClass('');
		}
		
		// eslint-disable-next-line
	}, []);

	return (
		<div className="mailbox">
			<div className="mailbox-toolbar">
				<div className="mailbox-toolbar-item"><span className="mailbox-toolbar-text">Mailboxes</span></div>
				<div className="mailbox-toolbar-item"><Link to="/email/inbox" className="mailbox-toolbar-link active">Inbox</Link></div>
				<div className="mailbox-toolbar-item"><Link to="/email/inbox" className="mailbox-toolbar-link">Sent</Link></div>
				<div className="mailbox-toolbar-item"><Link to="/email/inbox" className="mailbox-toolbar-link">Drafts (1)</Link></div>
				<div className="mailbox-toolbar-item"><Link to="/email/inbox" className="mailbox-toolbar-link">Junk</Link></div>
				<div className="mailbox-toolbar-item"><Link to="/email/compose" className="mailbox-toolbar-link text-theme bg-theme bg-opacity-10">New Message <i className="fa fa-pen fs-12px ms-1"></i></Link></div>
			</div>
			<div className="mailbox-body">
				<div className="mailbox-sidebar d-none d-lg-block">
					<PerfectScrollbar className="h-100">
						<div className="mailbox-list">
							{mailData && mailData.length > 0 ? (mailData.map((mail, index) => (
								<div key={index} className={'mailbox-list-item' + ((mail.unread) ? ' unread' : '') + ((mail.hasAttachment) ? ' has-attachment' : '')}>
									<div className="mailbox-checkbox">
										<div className="form-check">
											<input className="form-check-input" type="checkbox" value="" id={'mailCheckbox' + index} />
											<label className="form-check-label" htmlFor={'mailCheckbox'+ index}></label>
										</div>
									</div>
									<div className="mailbox-message">
										<Link to="/email/detail" className="mailbox-list-item-link">
											<div className="mailbox-sender">
												<span className="mailbox-sender-name">{mail.sender}</span>
												<span className="mailbox-time">{mail.time}</span>
											</div>
											<div className="mailbox-title">{mail.title}</div>
											<div className="mailbox-desc">{mail.desc}</div>
										</Link>
									</div>
								</div>
							))) : (
								<div className="mailbox-list-item" style={{ minWidth: '360px' }}>
									No records found
								</div>
							)}
						</div>
					</PerfectScrollbar>
				</div>
				<div className="mailbox-content">
					<PerfectScrollbar className="h-100">
						<div className="mailbox-detail">
							<div className="mailbox-detail-header">
								<div className="d-flex align-items-center">
									<a href="#/">
										<img src="/quantum-react/assets/img/user/user.jpg" alt="" width="36" />
									</a>
									<div className="flex-fill ms-3">
										<div className="d-flex align-items-center">
											<div className="flex-fill">
												<div className="fw-semibold"><span className="text-white">John Smith</span> &lt;johnsmith@studio.com&gt;</div>
												<div>
													<span>to</span> <a href="#/" className="text-decoration-none">sales@seantheme.com</a>, <a href="#/" className="text-decoration-none">support@seantheme.com</a>
												</div>
											</div>
											<div className="small text-end text-white text-opacity-50">Nov 27, 2026 <br />at 7.00pm</div>
										</div>
									</div>
								</div>
							</div>
							<div className="mailbox-detail-content">
								<h5 className="mb-4">Your payment is received</h5>
								<div className="mailbox-detail-attachment">
									<div className="mailbox-attachment">
										<a href="#/">
											<div className="document-file">
												<div className="icon">
													<Icon icon="material-symbols-light:article-outline-sharp" />
												</div>
											</div>
											<div className="document-name">invoice.zip</div>
										</a>
									</div>
									<div className="mailbox-attachment">
										<a href="#/">
											<div className="document-file">
												<div className="icon">
													<Icon icon="material-symbols-light:hangout-video-outline-sharp" />
												</div>
											</div>
											<div className="document-name">video.mp4</div>
										</a>
									</div>
									<div className="mailbox-attachment">
										<a href="#/">
											<div className="document-file">
												<img src="/quantum-react/assets/img/gallery/gallery-101.jpg" alt="" className="object-fit-cover h-60px w-100" />
											</div>
											<div className="document-name">image.jpg</div>
										</a>
									</div>
								</div>
								<div className="mb-4"><a href="#/" className="btn btn-sm bg-white bg-opacity-15 text-white px-3">DOWNLOAD</a></div>
								<div className="mailbox-detail-body">
									Hi Dear Customer,<br />
									<br />
									Lorem ipsum dolor sit amet, consectetur adipiscing elit. Cras vel auctor nisi, vel auctor orci. <br />
									Aenean in pretium odio, ut lacinia tellus. Nam sed sem ac enim porttitor vestibulum vitae at erat.<br />
									<br />
									Curabitur auctor non orci a molestie. Nunc non justo quis orci viverra pretium id ut est. <br />
									Nullam vitae dolor id enim consequat fermentum. Ut vel nibh tellus. <br />
									Duis finibus ante et augue fringilla, vitae scelerisque tortor pretium. <br />
									Phasellus quis eros erat. Nam sed justo libero.<br />
									<br />
									Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.<br />
									Sed tempus dapibus libero ac commodo.<br />
									<br />
									<br />
									Regards,<br />
									Twitter Inc,<br />
									795 Folsom Ave, Suite 600<br />
									San Francisco, CA 94107<br />
									P: (123) 456-7890<br />
								</div>
							</div>
						</div>
					</PerfectScrollbar>
				</div>
			</div>
		</div>
	)
}

export default EmailDetail;